import React from "react";

import { Constants as GridConstants } from "Components/AppGrid/shipeezi-new-grid";
import { useTranslation } from "react-i18next";
import { BsBoxSeam } from "react-icons/bs";

import Button, { Color } from "../../../../Form/Button";
import { DefaultTooltip } from "../../../Tooltip";
import useStyles from "../../styles";
import { CloseSSCCConfirmationModalHandles } from "../ModalCloseSSCC";

interface Props {
  show: boolean;
  disabled?: boolean;
  loading?: boolean;
  isThereCartonWithNoProducts: boolean;
  closeRef: React.RefObject<CloseSSCCConfirmationModalHandles>;
  title: string;
}

const CloseCartonButton = (props: Props) => {
  const { show, loading, disabled, closeRef, isThereCartonWithNoProducts, title } = props;

  const classes = useStyles();
  const { t: translate } = useTranslation();

  const onClick = () => closeRef.current?.open();

  if (!show) return null;

  return (
    <DefaultTooltip
      title={
        isThereCartonWithNoProducts
          ? translate("allSSCCMustHaveProductsInsideThemToBeClosed")
          : translate("closeSSCC")
      }
    >
      <div>
        <Button
          loading={loading}
          customColor={Color.SECONDARY_OUTLINED}
          onClick={onClick}
          disabled={disabled}
        >
          <div className={classes.printLabelButton}>
            <BsBoxSeam size={GridConstants.defaultRowActionSize} />
            <span className={classes.buttonText}>{title}</span>
          </div>
        </Button>
      </div>
    </DefaultTooltip>
  );
};

export default CloseCartonButton;
